<template>
  <div class="axj-main-menu-card">
    <div class="axj-main-menu-card-title">
      <div class="axj-main-menu-card-title-icon">
        <img :src="preViewUrl+data.menuIcon">
      </div>
      <div class="axj-main-menu-card-title-label">
        <label>{{data.menuTitle}}</label>
      </div>
    </div>
    <div class="axj-main-menu-card-menu" >
      <div class="axj-main-menu-card-menu-item" :key="child.url" v-for="child in data.children">
        <div class="axj-main-menu-card-menu-item-title" >
          <div class="axj-main-menu-card-menu-item-title-label">
            <label @click="handleClick" :targetUrl="child.url">
              {{ child.menuTitle }}
            </label>
          </div>
          <div class="axj-main-menu-card-menu-item-title-dot">
          </div>
        </div>
        <span>|</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "axj-main-menu",
  data(){
    return{
      axjMainMenuFiles:{
        axjMainMenuTitleIconZiXun:"/axj_web_file/icon/axj-menu/zixun.png"
      }
    }
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  props:{
    data:{
      type:Object,
      default:undefined
    }
  },
  created() {
    //cz6.5
  },
  methods:{
    handleClick(v){
      let url=v.target.getAttribute("targetUrl")
        this.$router.push({
          path:url
        })
      // if(v.target.outerText!='秀吧'){
      //   this.$router.push({
      //     path:"/error"
      //   })
      // }else{
      //   this.$router.push({
      //     path:"/axjMain"
      //   })
      // }
      let cards=document.querySelectorAll('.axj-main-menu-card')
      for(let i=0;i<cards.length;i++){
        let dots=cards[i].querySelectorAll('.axj-main-menu-card-menu-item-title')
        for(let x=0;x<dots.length;x++){
          dots[x].querySelector('.axj-main-menu-card-menu-item-title-dot').style.visibility='hidden'
          dots[x].querySelector('.axj-main-menu-card-menu-item-title-label').querySelector('label').style.color='#c9c9c9'
        }
      }
      console.log(v)
      v.target.parentElement.parentElement.querySelector('.axj-main-menu-card-menu-item-title-dot').style.visibility='visible'
      v.target.parentElement.parentElement.querySelector('.axj-main-menu-card-menu-item-title-label').querySelector('label').style.color='#000000'
    }
  }
}
</script>

<style scoped lang="scss">
.axj-main-menu-card{
  width: 228px;
  height: 110px;
  background: #FFFFFF;
  box-shadow: 0px 4px 27px rgba(0, 0, 0, 0.02);
  border-radius: 5px;
  display: flex;
  flex-flow: column;
  //background-color: #999999;
  .axj-main-menu-card-title{
    height: 48.94px;
    display: flex;
    align-items: center;
    width: 128.4px;
    //41.3+23.3+17.3+48+41.3=171.3
    justify-content: center;
    .axj-main-menu-card-title-icon{
      img{
        width: 20.24px;
        height:20.24px
        //441 748 410
        //2073600 0.000361 1136160
      }
      width: 20.24px;
      height:20.24px;
      margin-right: 13.5px;
    }
    .axj-main-menu-card-title-label{
      label{
        font-size: 17.6px;
        font-family: Source Han Sans CN;
        font-style: normal;
        font-weight: bold;
        color: #080C29;
      }
    }
  }
  .axj-main-menu-card-menu{
    margin-top: 0;
    padding: 0;
    width: 164px;
    margin-left: auto;
    display: flex;
    list-style: none;
    flex-wrap: wrap;
    font-family: Source Han Sans CN;
    font-style: normal;
    font-size: 14.6px;
    font-weight: 365;
    /* identical to box height, or 30px */
    color: #C9C9C9;
    .axj-main-menu-card-menu-item:not(:nth-child(3n+3)):not(:last-child){
      span{
        font-size: 15px;
        width: 16px;
        margin: 0;
        padding: 0;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .axj-main-menu-card-menu-item:nth-child(3n+3),:last-child{
      span{
        display: none;
      }
    }
    .axj-main-menu-card-menu-item{
      display: flex;
      align-items: flex-start;
      .axj-main-menu-card-menu-item-title{
        display: flex;
        flex-flow: column;
        align-items: center;
        height: 26px;
        justify-content: space-between;
        .axj-main-menu-card-menu-item-title-label{
          padding: 0;
          margin: 0;
         // background-color: black;
         display: flex;
          label:hover{
            cursor: pointer ;
            color: #00ADB5 !important;
          }
        }
        .axj-main-menu-card-menu-item-title-dot{
          visibility: hidden;
          height: 4px;
          width: 4px;
          border-radius: 4px;
          background-color: #00ADB5;
        }
      }
      // span{
      //   font-size: 3px;
      //   height: 22px;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-main/component/axj-main-menu/component/axj-main-menu-card/index.vue